export default "__VITE_ASSET__d3f24f38__"